const FIELD_GROUPS = {
  "Patient Information": [
    { key: 'provider', label: 'Provider' },
    { key: 'renderingFacility', label: 'Rendering Facility' },
    { key: 'taxId', label: 'Tax ID' },
    { key: 'ptName', label: 'Patient Name' },
    { key: 'dob', label: 'DOB' },
    { key: 'ssn', label: 'SSN' },
    { key: 'employer', label: 'Employer' },
    { key: 'solDate', label: 'SOL Date' },
    { key: 'adjNumber', label: 'Adj Number' },
    { key: 'doi', label: 'DOI' },
  ],
  "Billing Information": [
    { key: 'bill', label: 'Bill Amount' },
    { key: 'paid', label: 'Paid Amount' },
    { key: 'outstanding', label: 'Outstanding' },
    { key: 'offerAmount', label: 'Offer Amt' },
    { key: 'ledger', label: 'Ledger' },
    { key: 'hcf', label: 'HCF' },
    { key: 'invoice', label: 'Invoice' },
    { key: 'signinSheet', label: 'Signin Sheet' },
    { key: 'fds', label: 'FDS' },
    { key: 'lds', label: 'LDS' },
  ],
  "Insurance & Defense Information": [
    { key: 'insurance', label: 'Insurance' },
    { key: 'claimNo', label: 'Claim No' },
    { key: 'adjuster', label: 'Adjuster' },
    { key: 'adjusterPhone', label: 'Adj Phone' },
    { key: 'adjusterFax', label: 'Adj Fax' },
    { key: 'adjusterEmail', label: 'Adj Email' },
    { key: 'defenseAttorney', label: 'Defense Atty' },
    { key: 'defenseAttorneyPhone', label: 'DA Phone' },
    { key: 'defenseAttorneyFax', label: 'DA Fax' },
    { key: 'defenseAttorneyEmail', label: 'DA Email' },
  ],
  "Case & Hearing (Eams Status)": [
    { key: 'hearingStatus', label: 'Hearing Status' },
    { key: 'hearingDate', label: 'Hearing Date' },
    { key: 'hearingTime', label: 'Hearing Time' },
    { key: 'judgeName', label: 'Judge Name' },
    { key: 'courtRoomlink', label: 'Court Room Link' },
    { key: 'judgePhone', label: 'Judge Phone' },
    { key: 'AccesCode', label: 'Access Code' },
    { key: 'boardLocation', label: 'Board Location' },
    { key: 'lienStatus', label: 'Lien Status' },
    { key: 'caseStatus', label: 'Case Status' },
    { key: 'caseDate', label: 'Case Date' },
    { key: 'crAmount', label: 'C&R Amount' },
    { key: 'dorFiledBy', label: 'DOR Filed By' },
    { key: 'status4903_8', label: 'Status 4903.8' },
    { key: 'pmrStatus', label: 'PMR Status' },
    { key: 'judgeOrderStatus', label: 'Judge Order Status' },
  ],
  "Assignment": [{ key: 'assignedCollector', label: 'Collector' }],
};

const SAMPLE_ORDER = [
  'provider',
  'renderingFacility',
  'taxId',
  'ptName',
  'dob',
  'ssn',
  'employer',
  'insurance',
  'bill',
  'paid',
  'outstanding',
  'offerAmount',
  'ledger',
  'hcf',
  'invoice',
  'signinSheet',
  'fds',
  'lds',
  'solDate',
  'hearingStatus',
  'hearingDate',
  'hearingTime',
  'judgeName',
  'courtRoomlink',
  'judgePhone',
  'AccesCode',
  'boardLocation',
  'lienStatus',
  'caseStatus',
  'caseDate',
  'crAmount',
  'dorFiledBy',
  'status4903_8',
  'pmrStatus',
  'judgeOrderStatus',
  'adjuster',
  'adjusterPhone',
  'adjusterFax',
  'adjusterEmail',
  'defenseAttorney',
  'defenseAttorneyPhone',
  'defenseAttorneyFax',
  'defenseAttorneyEmail',
  'claimNo',
  'adjNumber',
  'doi',
];

const ALL_FIELDS_FLAT = Object.values(FIELD_GROUPS).flat();

export { FIELD_GROUPS, SAMPLE_ORDER, ALL_FIELDS_FLAT };
